import React from 'react'
import { FormattedMessage } from 'react-intl'

export default async function getMenuData() {
  return [
    {
      title: <FormattedMessage id="menu.dashboard" />,
      key: 'dashboard',
      icon: 'fe fe-home',
      url: '/dashboard',
    },
    {
      title: <FormattedMessage id="menu.customers" />,
      key: 'customers',
      icon: 'fe fe-users',
      url: '/customers',
    },
    // {
    //   title: <FormattedMessage id="menu.integrations" />,
    //   key: 'integrations',
    //   icon: 'fe fe-briefcase',
    //   url: '/integrations',
    // },
    {
      title: <FormattedMessage id="menu.marketing" />,
      key: 'posts',
      icon: 'fa fa-bullhorn',
      url: '/marketing',
    },
    {
      title: <FormattedMessage id="menu.inbox" />,
      key: 'inbox',
      icon: 'fe fe-inbox',
      url: '/inbox',
    },
    // {
    //   title: <FormattedMessage id="menu.digitalSignage" />,
    //   key: 'digital-signage',
    //   icon: 'fe fe-monitor',
    //   url: '/digital-signage',
    // },
    {
      title: <FormattedMessage id="menu.reports" />,
      key: 'reports',
      icon: 'fe fe-file-text',
      setBottom: true,
      children: [
        {
          title: <FormattedMessage id="menu.reports.rewardRedeemed" />,
          key: 'reward-redeemed',
          url: '/reports/reward-redeemed',
        },
        {
          title: <FormattedMessage id="menu.reports.giftIssued" />,
          key: 'gift-issued',
          url: '/reports/gift-issued',
        },
        {
          title: <FormattedMessage id="menu.reports.giftRedeemed" />,
          key: 'gift-redeemed',
          url: '/reports/gift-redeemed',
        },
        {
          title: <FormattedMessage id="menu.reports.allowanceIssued" />,
          key: 'allowance-issued',
          url: '/reports/provider-allowance-issued',
        },
        {
          title: <FormattedMessage id="menu.reports.allowanceRedeemed" />,
          key: 'allowance-redeemed',
          url: '/reports/provider-allowance-redeemed',
        },
        {
          title: <FormattedMessage id="menu.reports.communicationHistory" />,
          key: 'communication-history',
          url: '/reports/communication-history',
        },
        {
          title: <FormattedMessage id="menu.reports.missedCalls" />,
          key: 'missed-calls',
          url: '/reports/missed-calls',
        },
        {
          title: <FormattedMessage id="menu.reports.salesOverview" />,
          key: 'sales',
          url: '/reports/sales-overview',
        },
      ],
    },
    {
      title: <FormattedMessage id="menu.settings" />,
      key: 'settings',
      icon: 'fe fe-settings',
      setBottom: true,
      children: [
        {
          title: <FormattedMessage id="menu.settings.business_profile" />,
          key: 'business',
          url: '/settings/business-profile',
        },
        {
          title: <FormattedMessage id="menu.settings.brandSetup" />,
          key: 'brand',
          url: '/settings/brand',
        },
        {
          title: <FormattedMessage id="menu.settings.reward_program" />,
          key: 'reward-program',
          url: '/settings/reward-program',
        },
        {
          title: <FormattedMessage id="menu.customRewards" />,
          key: 'custom-rewards',
          url: '/custom-rewards',
        },
        {
          title: <FormattedMessage id="menu.settings.reward_card_design" />,
          key: 'card-design',
          url: '/settings/reward-card-design',
        },
        {
          title: <FormattedMessage id="menu.settings.giftCardDesign" />,
          key: 'gift-card-design',
          url: '/settings/gift-card-design',
        },
        {
          title: <FormattedMessage id="menu.settings.allowanceCardDesign" />,
          key: 'allowance-card-design',
          url: '/settings/provider-allowance-card-design',
        },
        {
          title: <FormattedMessage id="menu.settings.website_widget" />,
          key: 'website-widget',
          url: '/settings/website-widget',
        },
        {
          title: <FormattedMessage id="menu.settings.smartInboxSetup" />,
          key: 'smart-inbox-setup',
          url: '/settings/smart-inbox-setup',
        },
        {
          title: <FormattedMessage id="menu.settings.survey" />,
          key: 'survey',
          url: '/settings/feedback-questions',
        },
        {
          title: <FormattedMessage id="menu.customer_feeback" />,
          key: 'customer-feedback',
          url: '/customer-feedback',
        },
        {
          title: <FormattedMessage id="menu.integrations" />,
          key: 'integrations',
          url: '/integrations',
        },
        {
          title: <FormattedMessage id="menu.users" />,
          key: 'users',
          url: '/users',
        },
      ],
    },
    {
      title: <FormattedMessage id="menu.billing" />,
      key: 'billing',
      icon: 'fa fa-money',
      setBottom: true,
      children: [
        {
          title: <FormattedMessage id="menu.billingOverview" />,
          key: 'billing-overview',
          url: '/billing/overview',
        },
        {
          title: <FormattedMessage id="menu.invoices" />,
          key: 'invoices',
          url: '/billing/invoices',
        },
      ],
    },
    // {
    //   title: 'Dashboards',
    //   key: 'dashboards',
    //   icon: 'fe fe-home',
    //   // roles: ['admin'], // set user roles with access to this route
    //   // count: 4,
    //   children: [
    //     {
    //       title: 'Dashboard Alpha',
    //       key: 'dashboard',
    //       url: '/dashboard/alpha',
    //     },
    //     {
    //       title: 'Dashboard Beta',
    //       key: 'dashboardBeta',
    //       url: '/dashboard/beta',
    //     },
    //     {
    //       title: 'Dashboard Gamma',
    //       key: 'dashboardGamma',
    //       url: '/dashboard/gamma',
    //     },
    //     {
    //       title: 'Crypto Terminal',
    //       key: 'dashboardCrypto',
    //       url: '/dashboard/crypto',
    //     },
    //   ],
    // },
    // {
    //   category: true,
    //   title: 'Apps & Pages',
    // },
    // {
    //   title: 'Apps',
    //   key: 'apps',
    //   // icon: 'fe fe-database',
    //   children: [
    //     {
    //       title: 'Profile',
    //       key: 'appsProfile',
    //       url: '/apps/profile',
    //     },
    //     {
    //       title: 'Calendar',
    //       key: 'appsCalendar',
    //       url: '/apps/calendar',
    //     },
    //     {
    //       title: 'Gallery',
    //       key: 'appsGallery',
    //       url: '/apps/gallery',
    //     },
    //     {
    //       title: 'Messaging',
    //       key: 'appsCart',
    //       url: '/apps/messaging',
    //     },
    //     {
    //       title: 'Mail',
    //       key: 'appsMail',
    //       url: '/apps/mail',
    //     },
    //   ],
    // },
    // {
    //   title: 'Extra Apps',
    //   key: 'extraApps',
    //   // icon: 'fe fe-hard-drive',
    //   children: [
    //     {
    //       title: 'Github Explore',
    //       key: 'extraAppsGithubExplore',
    //       url: '/apps/github-explore',
    //     },
    //     {
    //       title: 'Github Discuss',
    //       key: 'extraAppsGithubDiscuss',
    //       url: '/apps/github-discuss',
    //     },
    //     {
    //       title: 'Digitalocean Droplets',
    //       key: 'extraAppsDigitaloceanDroplets',
    //       url: '/apps/digitalocean-droplets',
    //     },
    //     {
    //       title: 'Digitalocean Create',
    //       key: 'extraAppsDigitaloceanCreate',
    //       url: '/apps/digitalocean-create',
    //     },
    //     {
    //       title: 'Google Analytics',
    //       key: 'extraAppsGoogleAnalytis',
    //       url: '/apps/google-analytics',
    //     },
    //     {
    //       title: 'Wordpress Post',
    //       key: 'extraAppsWordpressPost',
    //       url: '/apps/wordpress-post',
    //     },
    //     {
    //       title: 'Wordpress Posts',
    //       key: 'extraAppsWordpressPosts',
    //       url: '/apps/wordpress-posts',
    //     },
    //     {
    //       title: 'Wordpress Add',
    //       key: 'extraAppsWordpressAdd',
    //       url: '/apps/wordpress-add',
    //     },
    //     {
    //       title: 'Todoist List',
    //       key: 'extraAppsTodoistList',
    //       url: '/apps/todoist-list',
    //     },
    //     {
    //       title: 'Jira Dashboard',
    //       key: 'extraAppsJiraDashboard',
    //       url: '/apps/jira-dashboard',
    //     },
    //     {
    //       title: 'Jira Agile Board',
    //       key: 'extraAppsJiraAgileBoard',
    //       url: '/apps/jira-agile-board',
    //     },
    //     {
    //       title: 'Helpdesk Dashboard',
    //       key: 'extraAppsHelpdeskDashboard',
    //       url: '/apps/helpdesk-dashboard',
    //     },
    //   ],
    // },
    // {
    //   title: 'Ecommerce',
    //   key: 'ecommerce',
    //   // icon: 'fe fe-shopping-cart',
    //   children: [
    //     {
    //       title: 'Dashboard',
    //       key: 'ecommerceDashboard',
    //       url: '/ecommerce/dashboard',
    //     },
    //     {
    //       title: 'Orders',
    //       key: 'ecommerceOrders',
    //       url: '/ecommerce/orders',
    //     },
    //     {
    //       title: 'Propduct Catalog',
    //       key: 'ecommerceProductCatalog',
    //       url: '/ecommerce/product-catalog',
    //     },
    //     {
    //       title: 'Product Details',
    //       key: 'ecommerceProductDetails',
    //       url: '/ecommerce/product-details',
    //     },
    //     {
    //       title: 'Cart',
    //       key: 'ecommerceCart',
    //       url: '/ecommerce/cart',
    //     },
    //   ],
    // },
    // {
    //   title: 'Auth Pages',
    //   key: 'auth',
    //   // icon: 'fe fe-user',
    //   children: [
    //     {
    //       title: 'Login',
    //       key: 'authLogin',
    //       url: '/account/login',
    //     },
    //     {
    //       title: 'Forgot Password',
    //       key: 'authForgotPassword',
    //       url: '/account/forgot-password',
    //     },
    //     {
    //       title: 'Register',
    //       key: 'authRegister',
    //       url: '/account/register',
    //     },
    //     {
    //       title: 'Reset Password',
    //       key: 'authResetPassword',
    //       url: '/account/reset-password',
    //     },
    //     {
    //       title: 'Verify Account',
    //       key: 'authVerifyAccount',
    //       url: '/account/verify-account',
    //     },
    //     {
    //       title: 'Lockscreen',
    //       key: 'authLockscreen',
    //       url: '/account/lockscreen',
    //     },
    //     {
    //       title: 'Page 404',
    //       key: 'auth404',
    //       url: '/account/404',
    //     },
    //     {
    //       title: 'Page 500',
    //       key: 'auth500',
    //       url: '/account/500',
    //     },
    //   ],
    // },
    // {
    //   category: true,
    //   title: 'UI Kits',
    // },
    // {
    //   title: 'Ant Design',
    //   key: 'antDesign',
    //   // icon: 'fe fe-bookmark',
    //   url: '/ui-kits/antd',
    // },
    // {
    //   title: 'Bootstrap',
    //   key: 'bootstrap',
    //   // icon: 'fe fe-bookmark',
    //   url: '/ui-kits/bootstrap',
    // },
    // {
    //   category: true,
    //   title: 'Components',
    // },
    // {
    //   title: 'Widgets',
    //   key: 'widgets',
    //   // icon: 'fe fe-image',
    //   count: 47,
    //   children: [
    //     {
    //       title: 'General',
    //       key: 'widgetsGeneral',
    //       url: '/widgets/general',
    //     },
    //     {
    //       title: 'Lists',
    //       key: 'widgetsLists',
    //       url: '/widgets/lists',
    //     },
    //     {
    //       title: 'Tables',
    //       key: 'widgetsTables',
    //       url: '/widgets/tables',
    //     },
    //     {
    //       title: 'Charts',
    //       key: 'widgetsCharts',
    //       url: '/widgets/charts',
    //     },
    //   ],
    // },
    // {
    //   title: 'Cards',
    //   key: 'cards',
    //   // icon: 'fe fe-credit-card',
    //   children: [
    //     {
    //       title: 'Basic Cards',
    //       key: 'cardsBasicCards',
    //       url: '/cards/basic-cards',
    //     },
    //     {
    //       title: 'Tabbed Cards',
    //       key: 'cardsTabbedCards',
    //       url: '/cards/tabbed-cards',
    //     },
    //   ],
    // },
    // {
    //   title: 'Tables',
    //   key: 'tables',
    //   // icon: 'fe fe-grid',
    //   children: [
    //     {
    //       title: 'Ant Design',
    //       key: 'tablesAntd',
    //       url: '/tables/antd',
    //     },
    //     {
    //       title: 'Bootstrap',
    //       key: 'tablesBootstrap',
    //       url: '/tables/bootstrap',
    //     },
    //   ],
    // },
    // {
    //   title: 'Charts',
    //   key: 'charts',
    //   // icon: 'fe fe-pie-chart',
    //   children: [
    //     {
    //       title: 'Chartist.js',
    //       key: 'chartsChartistjs',
    //       url: '/charts/chartistjs',
    //     },
    //     {
    //       title: 'Chart.js',
    //       key: 'chartsChartjs',
    //       url: '/charts/chartjs',
    //     },
    //     {
    //       title: 'C3',
    //       key: 'chartsC3',
    //       url: '/charts/c3',
    //     },
    //   ],
    // },
    // {
    //   title: 'Icons',
    //   key: 'icons',
    //   // icon: 'fe fe-star',
    //   children: [
    //     {
    //       title: 'Feather Icons',
    //       key: 'iconsFeatherIcons',
    //       url: '/icons/feather-icons',
    //     },
    //     {
    //       title: 'Fontawesome',
    //       key: 'iconsFontawesome',
    //       url: '/icons/fontawesome',
    //     },
    //     {
    //       title: 'Linearicons Free',
    //       key: 'iconsLineariconsFree',
    //       url: '/icons/linearicons-free',
    //     },
    //     {
    //       title: 'Icomoon Free',
    //       key: 'iconsIcomoonFree',
    //       url: '/icons/icomoon-free',
    //     },
    //   ],
    // },
    // {
    //   category: true,
    //   title: 'Advanced',
    // },
    // {
    //   title: 'Form Examples',
    //   key: 'formExamples',
    //   // icon: 'fe fe-menu',
    //   url: '/advanced/form-examples',
    // },
    // {
    //   title: 'Email Templates',
    //   key: 'emailTemplates',
    //   // icon: 'fe fe-mail',
    //   url: '/advanced/email-templates',
    // },
    // {
    //   title: 'Pricing Tables',
    //   key: 'pricingTables',
    //   // icon: 'fe fe-command',
    //   url: '/advanced/pricing-tables',
    // },
    // {
    //   title: 'Invoice',
    //   key: 'invoice',
    //   // icon: 'fe fe-file-text',
    //   url: '/advanced/invoice',
    // },
    // {
    //   title: 'Utilities',
    //   key: 'utilities',
    //   // icon: 'fe fe-inbox',
    //   url: '/advanced/utilities',
    // },
    // {
    //   title: 'Grid',
    //   key: 'grid',
    //   // icon: 'fe fe-grid',
    //   url: '/advanced/grid',
    // },
    // {
    //   title: 'Typography',
    //   key: 'typography',
    //   // icon: 'fe fe-type',
    //   url: '/advanced/typography',
    // },
    // {
    //   title: 'Colors',
    //   key: 'colors',
    //   // icon: 'fe fe-feather',
    //   url: '/advanced/colors',
    // },
    // {
    //   title: 'Nested Items',
    //   key: 'nestedItem1',
    //   // icon: 'fe fe-layers',
    //   disabled: true,
    //   children: [
    //     {
    //       title: 'Nested Item 1-1',
    //       key: 'nestedItem1-1',
    //       children: [
    //         {
    //           title: 'Nested Item 1-1-1',
    //           key: 'nestedItem1-1-1',
    //         },
    //         {
    //           title: 'Nested Items 1-1-2',
    //           key: 'nestedItem1-1-2',
    //           disabled: true,
    //         },
    //       ],
    //     },
    //     {
    //       title: 'Nested Items 1-2',
    //       key: 'nestedItem1-2',
    //     },
    //   ],
    // },
    // {
    //   title: 'Disabled Item',
    //   key: 'disabledItem',
    //   icon: 'fe fe-slash',
    //   disabled: true,
    // },
  ]
}
